export const TIME_IN_MILLISECONDS = {
  // minutes
  ONE_MINUTE: 60 * 1000,
  THREE_MINUTES: 60 * 1000 * 3,
  FIVE_MINUTES: 60 * 1000 * 5,
  TEN_MINUTES: 60 * 1000 * 10,
  // seconds
  ONE_SECOND: 1000,
  THREE_SECONDS: 3000,
  FOUR_SECONDS: 4000,
  FIVE_SECONDS: 5000,
  FIFTEEN_SECONDS: 15000,
  NINETY_SECONDS: 90000,
};

export const JS_SARTURDAY = 6;
export const JS_SUNDAY = 0;
export const OFF_WORKING_HOUR = 17;
export const today = new Date();
